import business from './steps/business';
import earlyDevelopment from './steps/earlyDevelopment';
import largeSite from './steps/largeSite';
import review from './steps/review';
import smallSite from './steps/smallSite';
import stateCritical from './steps/stateCritical';
import worksite from './steps/worksite';
import type { FormItem } from './types';

export const RadioToFormIdMap = {
  'small-site': 'smallSite',
  'large-site': 'largeSite',
  'state-critical': 'stateCritical',
  'early-development': 'earlyDevelopment'
};

const formData: { [stepId: string]: FormItem[] } = {
  business,
  worksite,
  smallSite,
  largeSite,
  stateCritical,
  earlyDevelopment,
  review
};

export default formData;
